export const webStyle = {
  backdropFilter: 'blur(2px)'
};
